import React from 'react';
import PropTypes from 'prop-types';

import AccessibleIcon from './AccessibleIcon';

const propTypes = {
    children: PropTypes.element,
    label: PropTypes.string.isRequired,
    asc: PropTypes.bool.isRequired
};

const defaultProps = {};

class SortIcon extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <AccessibleIcon
            label={this.props.label + " " + this.props.asc ? "Ascending" : "Descending"}>
                {this.props.children}
                {   this.props.asc ?
                        <span className="fa fa-sort-asc margin-left-sm" aria-hidden="true"/>
                        :
                        <span className="fa fa-sort-desc margin-left-sm" aria-hidden="true"/>
                }
            </AccessibleIcon>
        )
    }
}

SortIcon.propTypes = propTypes;
SortIcon.defaultProps = defaultProps;

export default SortIcon;